var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-page-header',{on:{"back":function($event){return _vm.$router.go(-1)}}}),(_vm.analysis)?_c('SATAnalysis',{attrs:{"type":"adaptive","analysis":_vm.analysis}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }